import { FrameValue } from 'react-spring'

/**
 * Clamps a value between the specified range.
 *
 * @param value
 * @param min
 * @param max
 */
export function clamp(value: number, min = 0, max = 1) {
  return Math.min(max, Math.max(min, value))
}

/**
 * Linear interpolation.
 *
 * @param start
 * @param end
 * @param amt
 */
export function lerp(start: number, end: number, amt: number) {
  return (1 - amt) * start + amt * end
}

/**
 * Utility for creating a prefab lerp function for a spring.
 *
 * @param value
 */
export function createSpringLerp(value: FrameValue<number>) {
  return (start: number, end: number) => value.to((v) => lerp(start, end, v))
}
